import * as React from 'react';

export const TotalRegistrationsActive = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="coupon">
      <path
        id="Vector"
        opacity="0.4"
        d="M19 12.0029C19 13.1029 19.9 14.0029 21 14.0029V17.0029C21 19.0029 20 20.0029 18 20.0029H6C4 20.0029 3 19.0029 3 17.0029V14.0029C4.1 14.0029 5 13.1029 5 12.0029C5 10.9029 4.1 10.0029 3 10.0029V7.00293C3 5.00293 4 4.00293 6 4.00293H18C20 4.00293 21 5.00293 21 7.00293V10.0029C19.9 10.0029 19 10.9029 19 12.0029Z"
        fill="#1D6EAA"
      />
      <path
        id="Vector_2"
        d="M15.75 4.00293V7.50293C15.75 7.91293 15.41 8.25293 15 8.25293C14.59 8.25293 14.25 7.91293 14.25 7.50293V4.00293H15.75ZM15.75 13.2529V10.7529C15.75 10.3389 15.414 10.0029 15 10.0029C14.586 10.0029 14.25 10.3389 14.25 10.7529V13.2529C14.25 13.6669 14.586 14.0029 15 14.0029C15.414 14.0029 15.75 13.6669 15.75 13.2529ZM14.25 20.0029V16.5029C14.25 16.0929 14.59 15.7529 15 15.7529C15.41 15.7529 15.75 16.0929 15.75 16.5029V20.0029H14.25Z"
        fill="#1D6EAA"
      />
    </g>
  </svg>
);
